<template>
  <div class>
    <!--=== Header Start ===-->
    <div
      class="
        page-effect
        RegEvent-wrapper
        edu-rage
        event_list_reg
        ss-pre-ev-list
      "
    >
      <section class="event-box-list-wrapper">
        <div class="container-fluid"></div>
      </section>
      <div class="category-seclect-patch">
        <h2>Choose an experience you want to create for your next event</h2>
      </div>
      <div class="container-fluid py-3 px-16 position-relative">
        <!--Populer Course start--->

        <h3 class="popular-head mt-3" v-if="showPopularCourses">
          Populer Course
        </h3>
        <carousel
          v-if="showPopularCourses"
          class="populer_slider"
          :autoplay="false"
          :nav="true"
          :margin="24"
          :loop="false"
          :dots="false"
          :responsive="{
            0: { items: 1 },
            600: { items: 3, nav: true },
            1000: { items: 4, nav: true },
          }"
        >
          <div v-for="template in defaultTemplates" :key="template.EventId">
            <div
              class="event-showcase-box"
              v-if="template.IsTemplatePublished && template.IsTemplatePinned"
              @click="openTemplateDetailsDialog(template)"
            >
              <div class="showcase-box-event-image">
                <img :src="getCDNUrl(template.DefaultShowcaseImageURL)" />
              </div>
              <div class="category-desc">
                <img :src="getCDNUrl(template.TemplateLogo)" />
                <h5>{{ template.EventFullName }}</h5>
              </div>
            </div>
          </div>

          <!-- <div class="event-showcase-box">
            <div class="showcase-box-event-image">
              <img src="../assets/Images/self-service/event-case.png" />
            </div>
            <div class="category-desc">
              <img src="../assets/Images/self-service//webinar.png" />
              <h5>Webinar</h5>
            </div>
          </div> -->

          <!-- <div class="event-showcase-box" @click="eventSetupEnterClick()">
            <div class="showcase-box-event-image">
              <img src="../assets/Images/self-service/thailand.png" />
            </div>
            <div class="category-desc">
              <img src="../assets/Images/self-service/community.png" />
              <h5>Community Event</h5>
            </div>
          </div> -->
          <!-- <div class="event-showcase-box" @click="eventSetupEnterClick()">
            <div class="showcase-box-event-image">
              <img src="../assets/Images/self-service/employee-event.png" />
            </div>
            <div class="category-desc">
              <img src="../assets/Images/self-service/employee.png" />
              <h5>Employee Event</h5>
            </div>
          </div> -->
          <!-- <div class="event-showcase-box" @click="eventSetupEnterClick()">
            <div class="showcase-box-event-image">
              <img src="../assets/Images/self-service/conference-case.png" />
            </div>
            <div class="category-desc">
              <img src="../assets/Images/self-service/Conference.png" />
              <h5>Conference</h5>
            </div>
          </div> -->
        </carousel>
        <!--Populer Course end--->
        <h3 class="popular-head mt-3">Playbook</h3>

        <v-row class="my-0">
          <v-col
            md="4"
            lg="3"
            cols="12"
            v-for="template in defaultTemplates"
            :key="template.EventId"
          >
            <div
              class="event-showcase-box cursor-pointer"
              v-if="template.IsTemplatePublished && !template.IsTemplatePinned"
              @click="openTemplateDetailsDialog(template)"
            >
              <div class="showcase-box-event-image">
                <img :src="getCDNUrl(template.DefaultShowcaseImageURL)" />
              </div>
              <div class="category-desc">
                <img :src="getCDNUrl(template.TemplateLogo)" />
                <h5>{{ template.EventFullName }}</h5>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      

      <v-dialog v-model="templateDetailsDialog" :retain-focus="false" width="1280">
        <v-card>
          <div
            class="
              headerdialog-showcase-wrap
              p-4
              d-flex
              justify-content-between
              align-items-center
              border-bottom
              mb-3
            "
          >
            <div
              class="
                showcase-left-wrap
                d-flex
                justify-content-start
                align-items-center
              "
            >
              <img
                :src="getCDNUrl(selectedTemplateEventLogo)"
                height="50px"
                width="auto"
              />
              <h3 v-if="selectedTemplateEventName">
                {{ selectedTemplateEventName }}
              </h3>
            </div>
            <div class="d-flex align-items-center">
              <div v-on="on" v-if="selectedTemplateId == 1">
                <v-btn
                  @click="cloneEventExperience()"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="clone-exp-butn px-3"
                  color="#1a73e8"
                  width="100%"
                  ><v-icon class="mr-2" color="#ffffff" size="25px"
                    >mdi-content-copy</v-icon
                  >
                  Clone this Experience</v-btn
                >
              </div>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on">
                    <v-btn
                      width="100%"
                      class="clone-exp-butn px-3"
                      color="#1a73e8"
                      depressed
                      disabled
                      v-bind="attrs"
                      v-on="on"
                      ><v-icon class="mr-2" color="#ffffff" size="25px"
                        >mdi-content-copy</v-icon
                      >
                      Clone this Experience</v-btn
                    >
                  </div>
                </template>
                <span class="v-tooltip-content v-tooltip-bottom"
                  >Coming Soon!</span
                >
              </v-tooltip>

              <v-btn icon large @click="templateDetailsDialog = false"
                ><v-icon color="#333333" size="25px">mdi-close</v-icon></v-btn
              >
            </div>
          </div>
          <v-card-text>
            <v-row class="my-0">
              <v-col md="5" lg="6" cols="12" class="pb-md-0">
                <!-- big thumb-slider -->
                <div
                  class="thumb-slider populer_slider"
                  v-if="selectedTemplateEventImages.length > 0"
                >
                  <hooper :settings="hooperSettings" group="group1">
                    <slide
                      v-for="selectedImg in selectedTemplateEventImages"
                      :key="selectedImg.Name"
                    >
                      <div class="rounded">
                        <img :src="getCDNUrl(selectedImg.ImageUrl)" />
                      </div>
                    </slide>
                    <hooper-navigation slot="hooper-addons"></hooper-navigation>
                  </hooper>
                </div>

                <!-- big thumb-slider end -->
                <!-- thumb-slider -->
                <div
                  class="thumb-slider populer_slider mt-3 sm-thumb-slider"
                  v-if="selectedTemplateEventImages.length > 0"
                >
                  <hooper :settings="hooperSettings2" group="group1">
                    <slide
                      v-for="selectedImg in selectedTemplateEventImages"
                      :key="selectedImg.Name"
                    >
                      <div class="rounded">
                        <img :src="getCDNUrl(selectedImg.ImageUrl)" />
                      </div>
                    </slide>
                    <hooper-navigation slot="hooper-addons"></hooper-navigation>
                    <hooper-pagination slot="hooper-addons"></hooper-pagination>
                  </hooper>
                </div>

                <!-- thumb-slider end -->
              </v-col>
              <v-col md="7" lg="6" cols="12" class="pb-md-0">
                <div class="event-showcase-description">
                  <p v-if="selectedTemplateEventDescription">
                    {{ selectedTemplateEventDescription }}
                  </p>

                  <h4 class="mt-8">Features</h4>
                  <div class="showcase-feature">
                    <ul>
                      <li
                        v-for="features in selectedTemplateFeatures"
                        :key="features.ID"
                      >
                        <div class="features-list" v-if="features.IconUrl">
                          <img :src="getCDNUrl(features.IconUrl)" />
                          <p>{{ features.Name }}</p>
                        </div>
                      </li>

                      <!-- <li>
                        <div class="features-list">
                          <img
                            src="../assets/Images/self-service/access-point.svg"
                          />
                          <p>Live Stage</p>
                        </div>
                      </li>
                      <li>
                        <div class="features-list">
                          <img src="../assets/Images/self-service/agenda.svg" />
                          <p>Agenda</p>
                        </div>
                      </li>
                      <li>
                        <div class="features-list">
                          <img
                            src="../assets/Images/self-service/exhibits.svg"
                          />
                          <p>Exhibits</p>
                        </div>
                      </li>
                      <li>
                        <div class="features-list">
                          <img
                            src="../assets/Images/self-service/attendees.svg"
                          />
                          <p>Attendees</p>
                        </div>
                      </li>
                      <li>
                        <div class="features-list">
                          <img
                            src="../assets/Images/self-service/speakers.svg"
                          />
                          <p>Speakers</p>
                        </div>
                      </li>
                      <li>
                        <div class="features-list">
                          <img
                            src="../assets/Images/self-service/1-1-meeting.svg"
                          />
                          <p>1:1 Meeting</p>
                        </div>
                      </li>
                      <li>
                        <div class="features-list">
                          <img
                            src="../assets/Images/self-service/resources.svg"
                          />
                          <p>Resources</p>
                        </div>
                      </li> -->
                    </ul>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
import carousel from "vue-owl-carousel";
// import jQuery from "jquery";
// let $ = jQuery;
//var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
// import axios from "axios";
import { bus } from "@/main";
import axios from "axios";
import APIs from "@/components/APIInit";
import router from "../router";
import store from "../store";

Vue.use(VueMoment, {
  moment,
});

export default {
  data() {
    return {
      hooperSettings: {
        itemsToShow: 0.5,
        centerMode: false,
      },
      hooperSettings2: {
        itemsToShow: 1.9,
        centerMode: true,
        loop: true,
      },
      templateDetailsDialog: false,
      defaultTemplates: [],
      selectedTemplateEventName: null,
      selectedTemplateEventLogo: null,
      selectedTemplateEventImages: [],
      selectedTemplateEventDescription: null,
      selectedTemplateFeatures: [],
      showPopularCourses: false,
      selectedTemplateId: null,
      selectedTemplateEventId: null,
      selectedTemplateClientId: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.fetchTemplateDetails();
  },
  methods: {
    cloneEventExperience() {
      console.log("clone");
      var currentSelectedEvent = {
        EventName: this.selectedTemplateEventName,
        EventLogo: this.selectedTemplateEventLogo,
        EventDescription: this.selectedTemplateEventDescription,
        EventId: this.selectedTemplateEventId,
        ClientId: this.selectedTemplateClientId,
      };
      store.commit("setClonedTemplateMasterDetails", currentSelectedEvent);
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj != undefined && obj !== null) {
        if (
          obj.user != undefined &&
          obj.user != null &&
          obj.user[0].Email != ""
        ) {
          router.push({ name: "BasicInfo" });
        } else {
          bus.$emit("openSigninPopup", true);
        }
      } else {
        bus.$emit("openSigninPopup", true);
      }
    },
    openTemplateDetailsDialog(template) {
      //var self = this;
      this.selectedTemplateEventLogo = template.TemplateLogo;
      this.selectedTemplateEventName = template.EventFullName;
      this.selectedTemplateEventImages = template.TemplateDetailedImages;
      this.selectedTemplateEventDescription = template.Description;
      this.selectedTemplateFeatures = template.Features;
      this.selectedTemplateId = template.TemplateId;
      this.selectedTemplateEventId = template.EventId;
      this.selectedTemplateClientId = template.ClientId;

      //     var $owl = $('.owl-carousel');
      // $owl.trigger('destroy.owl.carousel');

      // $owl.html($owl.find('.owl-stage-outer').html()).removeClass('owl-loaded');
      //   $owl.owlCarousel({
      //       //self.selectedTemplateEventImages = template.TemplateDetailedImages,
      //   });

      this.templateDetailsDialog = true;
      // setTimeout(() => {

      // }, 2000);
    },
    fetchTemplateDetails() {
      //const token = this.getSessionToken();
      bus.$emit("toggleLoader", true);
      axios
        .get(APIs.GetEventTemplates)
        .then((res) => {
          res.data.events.map((data) => {
            // data.Description = "This is a test template";
            if (data.IsTemplatePinned) {
              this.showPopularCourses = true;
            }
            data.IsTemplatePinned = false;
            data.IsTemplatePublished = true;

            this.defaultTemplates.push(data);

            // this.defaultTemplates.map((template) => {
            //   if (data.TemplateId == template.TemplateId) {
            //     template.EventId = data.EventId;
            //     template.ClientId = data.ClientId;
            //   }
            // });
          });

          this.defaultTemplates.sort(function (a, b) {
            let v1 = a.TemplateDisplayOrder;
            let v2 = b.TemplateDisplayOrder;
            return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
          });
          bus.$emit("toggleLoader", false);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  components: {
    carousel,
    Hooper,
    Slide,
    HooperNavigation,
  },
};
</script>
